import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    dir: 'ltr',
    firmName: 'Dar Al Masri Law',
    firmTagline: 'Attorneys & Legal Consultants',
    firmPortal: 'Client Portal',
    signOut: 'Sign out',
    loggedInAs: 'Logged in as',
    caseType: 'Case Type',
    caseNumber: 'Case Number',
    court: 'Court',
    filed: 'Filed',
    judge: 'Assigned Judge',
    nextHearing: 'Next Scheduled Hearing',
    daysAway: 'days away',
    hearingHistory: 'Hearing History',
    upcoming: 'Upcoming',
    documents: 'Case Documents',
    download: 'Download',
    lastUpdated: 'Last updated by',
    contactLawyer: 'For questions, contact your lawyer directly',
    status: 'Status',
    active: 'Active — In Progress',
    closed: 'Closed',
    pending: 'Pending',
    pleading: 'Pleading',
    record: 'Court Record',
    evidence: 'Evidence',
    order: 'Court Order',
    other: 'Document',
    loginTitle: 'Client Portal',
    loginSub: 'Sign in to access your case',
    emailLabel: 'Email address',
    passwordLabel: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    loginError: 'Invalid email or password. Please try again.',
    noCase: 'No case assigned to your account. Please contact your lawyer.',
    loading: 'Loading your case...',
    mb: 'MB',
    uploaded: 'Uploaded',
    changePassword: 'Change Password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    passwordsDontMatch: 'Passwords do not match.',
    passwordTooShort: 'Password must be at least 8 characters.',
    passwordChanged: 'Password updated successfully. Please sign in again.',
    changingPassword: 'Updating...',
    cancel: 'Cancel',
    save: 'Save',
  },
  ar: {
    dir: 'rtl',
    firmName: 'دار المصري',
    firmTagline: 'محامون ومستشارون',
    firmPortal: 'بوابة الموكل',
    signOut: 'تسجيل الخروج',
    loggedInAs: 'مسجّل دخولك كـ',
    caseType: 'نوع القضية',
    caseNumber: 'رقم القضية',
    court: 'المحكمة',
    filed: 'تاريخ التسجيل',
    judge: 'القاضي المختص',
    nextHearing: 'الجلسة القادمة',
    daysAway: 'يوماً',
    hearingHistory: 'سجل الجلسات',
    upcoming: 'قادمة',
    documents: 'وثائق القضية',
    download: 'تحميل',
    lastUpdated: 'آخر تحديث بواسطة',
    contactLawyer: 'للاستفسار، تواصل مع محاميك مباشرة',
    status: 'الحالة',
    active: 'نشطة — قيد النظر',
    closed: 'منتهية',
    pending: 'معلّقة',
    pleading: 'لائحة دعوى',
    record: 'محضر جلسة',
    evidence: 'دليل إثبات',
    order: 'قرار محكمة',
    other: 'وثيقة',
    loginTitle: 'بوابة الموكل',
    loginSub: 'سجّل دخولك للاطلاع على قضيتك',
    emailLabel: 'البريد الإلكتروني',
    passwordLabel: 'كلمة المرور',
    signIn: 'دخول',
    signingIn: 'جارٍ الدخول...',
    loginError: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    noCase: 'لا توجد قضية مرتبطة بحسابك. يرجى التواصل مع محاميك.',
    loading: 'جارٍ تحميل بيانات قضيتك...',
    mb: 'ميغابايت',
    uploaded: 'رُفع',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    passwordsDontMatch: 'كلمتا المرور غير متطابقتين.',
    passwordTooShort: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.',
    passwordChanged: 'تم تحديث كلمة المرور بنجاح. يرجى تسجيل الدخول مرة أخرى.',
    changingPassword: 'جارٍ التحديث...',
    cancel: 'إلغاء',
    save: 'حفظ',
  }
};

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState('ar');
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
